import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  public static API_ENDPOINT_OTHER = environment.baseUrlPogodaBackendOther;
  public static API_ENDPOINT_USERS = environment.baseUrlPogodaBackendUsers;
  public static API_ENDPOINT_ATLAS = environment.baseUrlAtlasBackend;
  public static API_ENDPOINT_STATIC = environment.baseUrlPogodaBackendStatic;
  public static API_ENDPOINT_PHOTOSTORE = environment.baseUrlPhotostore;
  // public static API_ENDPOINT_ASSETS = environment.baseUrlAssets;

  constructor() { }
}
